export var fileCardImageViewSelector = 'media-file-card-view';
export var fileCardImageViewSelectedSelector = 'media-file-card-view-selected';